module.exports = __webpack_public_path__ + "img/platform-6-icon.80b7a866.svg";